import { render, staticRenderFns } from "./ConfirmStock.vue?vue&type=template&id=1824970d&"
import script from "./ConfirmStock.vue?vue&type=script&lang=js&"
export * from "./ConfirmStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports